import React from "react";
import LayoutBarista from "../../../layout/layout_barista";
import StatsPage from "./stats_page";

export function BaristaStats() {
    return (
        <LayoutBarista>
            <StatsPage />
        </LayoutBarista>
    );
}
